document.addEventListener(
  'submit',
  function (event) {
    const form = event.target;
    const widget = form.querySelector('.cf-turnstile');
    if (!widget) return;

    const tokenInput = form.querySelector('[name="cf-turnstile-response"]');
    if (!tokenInput || !tokenInput.value) {
      event.preventDefault();

      let errorMsg = form.querySelector('.turnstile-error');
      if (!errorMsg) {
        errorMsg = document.createElement('small');
        errorMsg.className = 'turnstile-error form__message';
        errorMsg.style.cssText = 'display:block;margin-top:0.5rem;color:rgb(var(--color-error,235,0,27))';
        widget.insertAdjacentElement('afterend', errorMsg);
      }
      errorMsg.textContent = 'Please complete the security check before submitting.';
      widget.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  },
  true
);
